import { IPayStub } from 'src/interfaces';
import { PaymentsActionType } from '../action-types';
import { PaymentsAction } from '../actions';

interface PaymentsState {
  loading: boolean;
  error: string | null;
  data: { payments: IPayStub[] };
}

const initialState = {
  loading: false,
  error: null,
  data: { payments: [] },
};

const reducer = (state: PaymentsState = initialState, action: PaymentsAction): PaymentsState => {
  switch (action.type) {
    case PaymentsActionType.GET_PAYMENTS:
      return { loading: true, error: null, data: { payments: [] } };
    case PaymentsActionType.GET_PAYMENTS_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case PaymentsActionType.GET_PAYMENTS_FAILURE:
      return { loading: false, error: action.payload, data: { payments: [] } };
    default:
      return state;
  }
};

export default reducer;
